import { withInstall } from '@tav-ui/utils/with-install'
import FileTypeSelect from './index.vue'

export * from './types'
export const TaFileTypeSelect = withInstall(FileTypeSelect)
export default TaFileTypeSelect
